import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8919b6b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "is-flex title-wrapper mb-2"
}
const _hoisted_2 = { class: "title ml-2" }
const _hoisted_3 = {
  key: 1,
  class: "description"
}
const _hoisted_4 = {
  key: 2,
  class: "divider my-4"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "icon-wrapper" }
const _hoisted_7 = { class: "level-info-title" }

import Sanitize from '@/popup/components/shared/Sanitize.vue'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import Switch from '@/popup/components/shared/Form/Switch.vue'
import IconButton from '@/popup/components/shared/IconButton.vue'
import { PermissionLevels } from '@/shared/Permissions'

type Emits = {
  (event: 'on-change', permissionName: string, isChecked: boolean): void
  (event: 'on-open-detail', permissionName: string): void
}

type Props = {
  icon: string
  actionIcon: string
  color: string
  title?: string
  description?: string
  control: string
  permissions: PermissionLevels[]
  marginClasses?: string[]
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PermissionsBlock',
  props: {
    icon: {},
    actionIcon: {},
    color: {},
    title: { default: () => '' },
    description: { default: () => '' },
    control: {},
    permissions: {},
    marginClasses: { default: () => ['mt-6', 'p-4'] },
    disabled: { type: Boolean }
  },
  emits: ["on-change", "on-open-detail"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit



const onOpenDetail = (name: string) => {
  emits('on-open-detail', name)
}

const onChange = (permissionName: string, isChecked: boolean) => {
  emits('on-change', permissionName, isChecked)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([..._ctx.marginClasses, 'permissions-level-wrapper'])
  }, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(SvgIcon, {
            height: "13",
            width: "13",
            color: _ctx.color,
            name: _ctx.icon
          }, null, 8 /* PROPS */, ["color", "name"]),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.description), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (_ctx.description || _ctx.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "default"),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissions, ({
        type,
        info,
        icon: _icon,
        isActive,
        isForward,
        permissionName,
      }) => {
      return (_openBlock(), _createElementBlock("div", {
        key: permissionName,
        class: _normalizeClass(["level-info mb-4", isForward ? 'is-clickable' : '']),
        onClick: 
        () => {
          if (isForward) {
            onOpenDetail(permissionName)
          }
        }
      
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(SvgIcon, {
            class: _normalizeClass([{ 'is-active': isActive }, "active"]),
            height: "40",
            width: "40",
            name: `${_icon || permissionName.toLowerCase()}-activated`,
            color: _ctx.color
          }, null, 8 /* PROPS */, ["class", "name", "color"]),
          _createVNode(SvgIcon, {
            class: "inactive",
            height: "40",
            width: "40",
            name: `${_icon || permissionName.toLowerCase()}-inactive`,
            color: _ctx.color
          }, null, 8 /* PROPS */, ["name", "color"])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t(type)), 1 /* TEXT */),
          _createVNode(Sanitize, {
            class: "level-info-description",
            html: 
            _ctx.$t(info, {
              control: _ctx.control,
            })
          
          }, null, 8 /* PROPS */, ["html"])
        ]),
        isForward
          ? (_openBlock(), _createBlock(IconButton, {
              key: 0,
              name: "arrow-right-lg",
              onOnClick: () => onOpenDetail(permissionName)
            }, null, 8 /* PROPS */, ["onOnClick"]))
          : (_openBlock(), _createBlock(Switch, {
              key: 1,
              "is-disabled": _ctx.disabled,
              "data-testid": permissionName.toLowerCase(),
              name: permissionName.toLowerCase(),
              onOnChange: 
          checked => {
            onChange(permissionName, checked)
          }
        ,
              "is-checked": isActive
            }, null, 8 /* PROPS */, ["is-disabled", "data-testid", "name", "onOnChange", "is-checked"]))
      ], 10 /* CLASS, PROPS */, _hoisted_5))
    }), 128 /* KEYED_FRAGMENT */))
  ], 2 /* CLASS */))
}
}

})